<template>
    <v-expansion-panels accordion class="mb-2">
        <v-expansion-panel>
            <v-expansion-panel-header v-model="open">
                <h4 class="text--primary">{{label}}</h4>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <p style="line-height: 1"><small>{{$translate('Leave the fields empty to inherit from the common setting. The specified value is always inherited by larger units if no value is set.')}}</small></p>
                <div class="d-flex">
                    <div style="width:17%; margin:0 1%">
                        <v-icon>mdi-cellphone</v-icon><br>
                        <v-text-field :label="$translate('Mobile')" type="number" color="zoezi-edit-color" v-model="xs" @input="setValue" min="1" max="12" hint="< 600px" />
                    </div>
                    <div style="width:18%; margin:0 1%">
                        <v-icon>mdi-tablet-android</v-icon><br>
                        <v-text-field :label="$translate('Tablet')" type="number" color="zoezi-edit-color" v-model="sm" @input="setValue" min="1" max="12" hint="600-960px" />
                    </div>
                    <div style="width:18%; margin:0 1%">
                        <v-icon>mdi-laptop</v-icon><br>
                        <v-text-field :label="$translate('Laptop')" type="number" color="zoezi-edit-color" v-model="md" @input="setValue" min="1" max="12" hint="960-1280px" />
                    </div>
                    <div style="width:20%; margin:0 1%">
                        <v-icon>mdi-monitor</v-icon><br>
                        <v-text-field :label="$translate('Computer')" type="number" color="zoezi-edit-color" v-model="lg" @input="setValue" min="1" max="12" hint="1280-1920px" />
                    </div>
                    <div style="width:17%; margin:0 1%">
                        <v-icon>mdi-desktop-mac</v-icon>
                        <v-text-field :label="$translate('Wide')" type="number" color="zoezi-edit-color" v-model="xl" @input="setValue" min="1" max="12" hint="1920px >" />
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: 'BreakpointSetting',

    watch: {
        value: {
            immediate: true,
            handler(v) {
                this.xs = v?.xs;
                this.sm = v?.sm;
                this.md = v?.md;
                this.lg = v?.lg;
                this.xl = v?.xl;
            }
        }
    },

    props: ['value', 'label'],
    data: () => ({
        xs: null,
        sm: null,
        md: null,
        lg: null,
        xl: null,
        open:false
    }),
    methods: {
        setValue() {
            this.$emit('input', {xs: this.xs, sm: this.sm, md: this.md, lg: this.lg, xl: this.xl});
        }
    }
}
</script>
